import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warc-viewer',
  templateUrl: './warc-viewer.component.html',
  styleUrls: ['./warc-viewer.component.css']
})
export class WarcViewerComponent implements OnInit {
  fileSource = '';

  constructor(public dialogRef: MatDialogRef<WarcViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data && this.data.url) {
      this.fileSource = this.data.url;
    }
    else {
      this.fileSource = 'https://vptcontentcrawler.s3.ap-south-1.amazonaws.com/warc/nowarc.wacz'
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
